export default __webpack_public_path__ + "device_cf.064b5677.png";